import Logout from '@mui/icons-material/Logout';
import Pause from '@mui/icons-material/Pause';
import { IconButton, Stack, Typography } from '@mui/material';
import { AutomaticFlowIcon, colors, theme } from '@silbo/ui';
import { useTranslation } from 'react-i18next';

type HeaderProps = {
  name: string;
  autoDispatchEnabled: boolean;
  onLogout: () => void;
  onTakeBreak: () => void;
};

const Header = ({ name, autoDispatchEnabled, onLogout, onTakeBreak }: HeaderProps) => {
  const { t } = useTranslation('patient-transport');

  return (
    <Stack position="sticky" top={0} zIndex={theme.zIndex.appBar} bgcolor={theme.palette.background.default}>
      <Stack padding={4} justifyContent="space-between" direction="row" alignItems="center">
        <Typography variant="h4" flex={1}>
          {t('helloUser', { name })}
        </Typography>
        <Stack direction="row" gap={4}>
          <IconButton variant="light" color="primary" onClick={onTakeBreak} size="large">
            <Pause />
          </IconButton>
          <IconButton variant="light" color="primary" onClick={onLogout} size="large">
            <Logout />
          </IconButton>
        </Stack>
      </Stack>
      {autoDispatchEnabled && (
        <Stack
          direction="row"
          paddingY={3}
          paddingX={4}
          gap={3}
          bgcolor={colors.orange[20]}
          color={colors.orange[90]}
          justifyContent="center"
        >
          <AutomaticFlowIcon sx={{ fontSize: 20 }} />
          <Typography fontWeight={600}>{t('autoDispatch')}</Typography>
        </Stack>
      )}
    </Stack>
  );
};

export default Header;
